<div class="view-container" [testId]="'aiff-setting-list-container'">
  <div class="header-fixed" [testId]="'aiff-setting-list-header'">
    <!-- 操作区域 -->
    <div class="action-container" [testId]="'aiff-setting-list-actions'">
      <button
        nz-button
        (click)="refresh()"
        [nzTooltipTitle]="'common.refresh' | i18n"
        nz-tooltip
        [testId]="'aiff-setting-list-refresh-button'"
      >
        <nz-icon nzType="reload" nzTheme="outline" [testId]="'aiff-setting-list-refresh-icon'" />
        <span>{{ 'common.refresh' | i18n }}</span>
      </button>
      <button nz-button nzType="primary" (click)="addSetting()" [testId]="'aiff-setting-list-add-button'">
        <nz-icon nzType="plus" nzTheme="outline" [testId]="'aiff-setting-list-add-icon'" />
        <span>{{ 'tenant.aiff.setting.add' | i18n }}</span>
      </button>
    </div>
  </div>

  <div class="content-scrollable" [testId]="'aiff-setting-list-content'">
    <nz-table
      [testId]="'aiff-setting-list-table'"
      #basicTable
      class="content-table"
      [nzData]="listOfData"
      [nzLoading]="loading"
      [nzShowPagination]="false"
      [nzFrontPagination]="false"
    >
      <thead [testId]="'aiff-setting-list-table-head'">
        <tr [testId]="'aiff-setting-list-table-header-row'">
          <th scope="col" [testId]="'aiff-setting-list-header-type'">{{ 'tenant.aiff.setting.type' | i18n }}</th>
          <th scope="col" [testId]="'aiff-setting-list-header-display-location'">{{ 'tenant.aiff.setting.embed.location' | i18n }}</th>
          <th scope="col" [testId]="'aiff-setting-list-header-service-number'">{{ 'tenant.aiff.setting.service.number' | i18n }}</th>
          <th scope="col" [testId]="'aiff-setting-list-header-popup-size'">{{ 'tenant.aiff.setting.popup.size' | i18n }}</th>
          <th scope="col" [testId]="'aiff-setting-list-header-support-device'">{{ 'tenant.aiff.setting.support.device' | i18n }}</th>
          <th scope="col" [testId]="'aiff-setting-list-header-update-time'">{{ 'tenant.aiff.setting.update.time' | i18n }}</th>
          <th scope="col" [testId]="'aiff-setting-list-header-actions'">{{ 'common.actions' | i18n }}</th>
        </tr>
      </thead>
      <tbody [testId]="'aiff-setting-list-table-body'">
        <tr *ngFor="let item of listOfData" [testId]="'aiff-setting-list-table-row-' + item.id">
          <td [testId]="'aiff-setting-list-cell-type'">
            <nz-tag [nzColor]="getDisplayTypeColor(item.displayType)" [testId]="'aiff-setting-list-type-tag'">
              {{ getDisplayTypeText(item.displayType) }}
            </nz-tag>
          </td>
          <td [testId]="'aiff-setting-list-cell-display-location'">{{ getDisplayLocationText(item.displayLocation) }}</td>
          <td [testId]="'aiff-setting-list-cell-service-number'">{{ item.serviceNumberIds?.length || 0 }}</td>
          <td [testId]="'aiff-setting-list-cell-popup-size'">{{ getPopupSizeText(item.popupSize) }}</td>
          <td [testId]="'aiff-setting-list-cell-support-device'">{{ getSupportDeviceText(item.supportDevice) }}</td>
          <td [testId]="'aiff-setting-list-cell-update-time'">{{ item.updateTime | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
          <td [testId]="'aiff-setting-list-cell-actions'">
            <button
              [testId]="'aiff-setting-list-edit-button'"
              nz-button
              nzType="primary"
              nzSize="small"
              nzShape="circle"
              (click)="editSetting(item.id)"
              [nzTooltipTitle]="'common.edit' | i18n"
              nz-tooltip
            >
              <nz-icon nzType="edit" nzTheme="outline" [testId]="'aiff-setting-list-edit-icon'" />
            </button>
            <nz-divider nzType="vertical" [testId]="'aiff-setting-list-divider'" />
            <button
              [testId]="'aiff-setting-list-delete-button'"
              nz-button
              nzType="primary"
              nzDanger
              nzSize="small"
              nzShape="circle"
              (click)="deleteSetting(item.id)"
              [nzTooltipTitle]="'common.delete' | i18n"
              nz-tooltip
            >
              <nz-icon nzType="delete" nzTheme="outline" [testId]="'aiff-setting-list-delete-icon'" />
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>

  <div class="pagination-container" [testId]="'aiff-setting-list-pagination-container'">
    <div class="custom-pagination" [testId]="'aiff-setting-list-pagination'">
      <span class="total-records" *ngIf="total > 0" [testId]="'aiff-setting-list-total-records'">
        {{ 'common.total.records' | i18n: { count: total } }}
      </span>
      <nz-pagination
        [testId]="'aiff-setting-list-pagination-component'"
        [(nzPageIndex)]="pageIndex"
        [(nzPageSize)]="pageSize"
        [nzTotal]="total"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
        [nzPageSizeOptions]="[10, 20, 50, 100]"
        nzShowSizeChanger
      />
    </div>
  </div>
</div>
